import React, { useState } from "react";
import { Avatar, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Lightbox } from "react-modal-image";

const useStyles = makeStyles(() => ({
  photoButton: {
    padding: 0,
    margin: 15,
    borderRadius: 10,
  },
  messageMedia: {
    objectFit: "cover",
    width: 160,
    height: 160,
    borderRadius: 10,
  },
}));

const ModalImageContatc = ({ imageUrl }) => {
  const classes = useStyles();
  const [failedUrl, setFailedUrl] = useState(null);
  const [loadedUrl, setLoadedUrl] = useState(null);
  const [expandedUrl, setExpandedUrl] = useState(null);
  const unavailable = !imageUrl || failedUrl === imageUrl;
  const loaded = !unavailable && loadedUrl === imageUrl;

  return (
    <>
      <IconButton
        className={classes.photoButton}
        aria-label="Ampliar foto do contato"
        disabled={!loaded}
        onClick={() => setExpandedUrl(imageUrl)}
      >
        {unavailable ? (
          <Avatar
            className={classes.messageMedia}
            variant="rounded"
            role="img"
            aria-label="Foto do contato indisponível"
          />
        ) : (
          <img
            key={imageUrl}
            className={classes.messageMedia}
            src={imageUrl}
            alt="Foto do contato"
            onLoad={() => setLoadedUrl(imageUrl)}
            onError={() => {
              setFailedUrl(imageUrl);
              setExpandedUrl(null);
            }}
          />
        )}
      </IconButton>
      {loaded && expandedUrl === imageUrl && (
        <Lightbox
          medium={imageUrl}
          large={imageUrl}
          alt="Foto do contato"
          showRotate={true}
          onClose={() => setExpandedUrl(null)}
        />
      )}
    </>
  );
};

export default ModalImageContatc;
